<template>
    <b-row>
        <b-col lg="12">
            <!-- .name -->
            <validation-observer ref="registerForm" #default="{ invalid }">
                <b-form>
                    <b-row>
                        
                    </b-row>
                    <hr />
                    <b-row>
                        <b-col lg="6">
                            <b-button block
                                      type="submit"
                                      :disabled="invalid"
                                      variant="primary"
                                      @click="submit()">
                                <i class="fa fa-plus" /> {{ $t("site.save") }}
                            </b-button>
                        </b-col>
                        <b-col lg="6">
                            <b-button block  @click="goToTable()"  variant="success">
                                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </b-col>
    </b-row>
</template>

<script>
    import Controller from '@/Controllers/CommentController';
    import config from '@/config/config';
    import { ValidationProvider, ValidationObserver } from "vee-validate";
   
    export default {
        name: "CommentForm",
        props: ['newItem'],
        components: {
            ValidationProvider,
            ValidationObserver,
            required,
        },
        data() {
            return {
                file: {},
                
                         

            };
        },
        methods: {
            async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
                let ret = await new Controller().From(this.newItem, "FormData");
                if (ret) {
                    this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
                    this.$parent.$parent.firstTab();
                }
            },
        },

};
</script>

